var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 8.29167V6.70833H4.54165V4.33333L0.583313 7.5L4.54165 10.6667V8.29167H11.6666Z",
    fill: "#485D68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 0.375H7.70831C6.8351 0.375 6.12498 1.08512 6.12498 1.95833V5.125H7.70831V1.95833H14.8333V13.0417H7.70831V9.875H6.12498V13.0417C6.12498 13.9149 6.8351 14.625 7.70831 14.625H14.8333C15.7065 14.625 16.4166 13.9149 16.4166 13.0417V1.95833C16.4166 1.08512 15.7065 0.375 14.8333 0.375Z",
    fill: "#485D68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.a1badca4ee375583254bf93e7dbc99b5.svg";
export { ForwardRef as ReactComponent };